<template>
  <v-sheet class="mx-auto" max-width="2000">
    <template v-for="(rareDiseaseSpecificQuestions, index) in rareDiseaseSpecificQuestionsData"
              :key="rareDiseaseSpecificQuestions.title">
      <v-card class="mx-auto" color="primary" variant="text" elevation="0"
              :title="rareDiseaseSpecificQuestions.title"
              :ref="el => { divs[index] = el }">
        <v-card-subtitle class="text-wrap" v-if="rareDiseaseSpecificQuestions.subTitle?.length > 0">
          {{ rareDiseaseSpecificQuestions.subTitle }}
        </v-card-subtitle>
        <v-row no-gutters>
          <v-col>
            <v-data-table :headers="rareDiseaseSpecificQuestions.headers"
                          :items="rareDiseaseSpecificQuestions.items"
                          density="compact"
                          :fixed-header="true"
                          :items-per-page="0">
              <template #bottom></template>
              <template v-slot:no-data>
                <v-progress-circular color="primary" indeterminate></v-progress-circular>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col class="text-right">
            <vue-to-print :content="() => divs[index].$el"
                          :document-title="icd + '-specific-questions-' + rareDiseaseSpecificQuestions.title"
                          remove-after-print>
              <template v-slot:trigger>
                <v-btn variant="plain" icon="mdi-printer" class="end"></v-btn>
              </template>
            </vue-to-print>
          </v-col>
        </v-row>
      </v-card>
    </template>
  </v-sheet>
</template>

<script>
import {defineComponent} from 'vue';
import axios from "axios";
import { VueToPrint } from "vue-to-print";
import { ref, reactive } from "vue";

export default defineComponent({
  name: 'RareDiseaseSpecificQuestions',
  props: {
    icd: String,
    icdDescription: String,
    visible: Boolean
  },
  components: {
    VueToPrint
  },
  data: () => ({
    rareDiseaseSpecificQuestionsData: [],
    divs: ref([])
  }),
  methods: {
    async loadSpecificQuestionsData() {
      return axios.get('rare-disease/specific_questions',
          {
            headers: { Authorization: `Bearer ${this.$store.getters.stateUser.keycloak_token}` },
            params: {
              icd: this.icd
            }
          });
    }
  },
  async mounted() {
    await Promise.all([
      this.loadSpecificQuestionsData()
    ]).then(responses => {
      this.rareDiseaseSpecificQuestionsData = reactive(responses[0].data)
    })
  }
});
</script>

<style scoped>
@media print {
  .mx-auto {
    zoom: 50%;
  }
}
</style>
